import React, { useEffect, useState, useRef } from 'react';
import _ from 'lodash';
import 'hammerjs';
import SCurveChart from '../../common/SCurveChart';
import { Circles } from 'react-loader-spinner';
import { Box, Typography } from '@mui/material';
import TileTitle from '../../common/tileTitle';



const ProgressChartWithTitle = ({ height, width, title, chartData, unit, chart_id,maxYaxis , colors}) => {


    const legendRef = useRef(null);

    const [legendContainer, setLegendContainer] = useState(null);

    useEffect(() => {
      setLegendContainer(legendRef.current);
    }, [chartData]);

    const columnItems =

    {
        week: [{
            name: "주간 계획",
            field_name: "PV",
            color: colors[0],
        },
        {
            name: "주간 실적",
            field_name: "EV",
            color: colors[1],
        },]
        ,
        month: [{
            name: "월간 계획",
            field_name: "PV",
            color:colors[0],
        },
        {
            name: "월간 실적",
            field_name: "EV",
            color:colors[1],
        },]
    }


    const lineItems = [
        {
            name: "누적 계획",
            field_name: "cumulativePV",
            color: colors[0],
        },
        {
            name: "누적 실적",
            field_name: "cumulativeEV",
            color: colors[1],
        },
    ];


    return (
        <Box
          sx={{
            padding: '20px',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: '10px',
              height: 28,
              borderBottom: '1px solid #D1D1D1',
            }}
          >
            <TileTitle>{title}</TileTitle>
            <div
              style={{
                zIndex: 99999,
                fontSize: 9,
                height: 40,
                width: 325,
                whiteSpace: 'nowrap',
              }}
              ref={legendRef}
            ></div>
          </Box>
      
          <Box sx={{ position: 'relative', flexGrow: 1 }}>
            {chartData && chartData.monthProgress &&  chartData.monthProgress.length>0 ? (
              // Render the chart when data is available and not loading
              <SCurveChart
              key={JSON.stringify(chartData)}

                data={chartData}
                columnItems={columnItems}
                lineItems={lineItems}
                chart_id={chart_id}
                height={height - 50}
                category='date'
                lineLabel={true}
                width={width}
                unit={unit}
                legendContainer={legendContainer}
                maxYaxis={maxYaxis}
              />
            ) : (
              // Show a message if there's no data
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <Typography variant="body2">데이터가 존재하지 않습니다.</Typography>
              </Box>
            )}
          </Box>
        </Box>
      );
}



export default ProgressChartWithTitle

